import React, { Component, createRef } from "react";
import Button from "@material-ui/core/Button";
import Utils from "../../../provider/Utils";
import FetchServerData from "../../../provider/FetchServerData";
import PaypalLogo from "../../../assets/img/paypallogo.png";
import logo from "../../../assets/img/givebelogo.png";
import "./PaypalDonation.css";
class PaypalDonation extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const urlTid = str.get("t");
    const twilioLogId = str.get("i");
    const amount = str.get("amount");

    this.state = {
      urlTid: urlTid,
      twilioLogId: twilioLogId,
      amount: amount ? parseFloat(amount) : 0,
      phone: "",
      businessEmail: "",
      messageName: "",
      selectedOption: "Weekly",
      optionIndex: 0,
      organization: null,
      pledgeCallbackUrl: null,
      isPledge: false,
      render: false,
      isAmount: amount === null ? true : false,
    };
    this.formRef = createRef(); // Form reference
    this.getMessageLogDetails(urlTid, twilioLogId);
  }

  getMessageLogDetails(urlTid, twilioLogId) {
    const postObject = {
      header: { tid: urlTid },
      twilioSmsLog: {
        id: twilioLogId,
      },
    };
    FetchServerData.callPostService("/smsLogms/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let twilioSmsLogDeatils = output.data.twilioSmsLog;
          let organizationDetails = twilioSmsLogDeatils?.organization;
          let messageDetails = twilioSmsLogDeatils?.messageLog?.message;
          this.setState({
            render: true,
            organization: organizationDetails,
            twilioLogId: twilioSmsLogDeatils?.id,
            pledgeCallbackUrl: twilioSmsLogDeatils?.pledgeCallbackUrl,
            businessEmail: "sb-merchant@business.example.com",
            messageName: messageDetails?.messageName,
            isPledge: messageDetails?.isPledge,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleAmountChange = (event) => {
    this.setState({ amount: parseFloat(event.target.value) });
  };

  submitForm = () => {
    if (this.formRef.current) {
      this.formRef.current.submit(); // Submit the form
    }
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    console.log("URLSearchParams =>", params)

    const status = params.get("status");
    const tx = params.get("tx");

    if (status && tx) {
      console.log("status =>", status, "tx =>", tx)
      if (status.toLowerCase() === "success") {
        this.handlePaymentSuccess(tx);
      } else {
        this.setState({ paymentStatus: "failed" });
      }
    }
  }

  handleOptionChange = (option, period) => {
    this.setState({ selectedOption: option, optionIndex: period });
  };

  render() {
    const {
      amount,
      pledgeCallbackUrl,
      businessEmail,
      messageName,
      isAmount,
      optionIndex,
      isPledge,
    } = this.state;
    const currency = "USD";
    const notifyUrl = pledgeCallbackUrl;
    const successUrl =
      pledgeCallbackUrl + "?amount=" + amount + "&status=Sucess";
    const cancelUrl =
      pledgeCallbackUrl + "?amount=" + amount + "&status=Failed";
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <div className="row m-4 justify-content-center">
          <div className="col-md-3">
            <div className="row">
              <div className="col-md-12 text-center" id="assetFormLabel">
                <div
                  style={{
                    display: "inline-flex",
                  }}
                >
                  {this.state.organization?.orgLogoDocument?.url !== null ? (
                    <a href="http://localhost:3000/" target="_blank">
                      <img
                        src={this.state.organization?.orgLogoDocument?.url}
                        style={{
                          width: "240Px",
                          height: "60px",
                          objectFit: "contain",
                        }}
                        alt="logo"
                      />
                    </a>
                  ) : (
                    <spna
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#353538",
                      }}
                    >
                      {this.state.organization?.name}
                    </spna>
                  )}
                </div>
              </div>
            </div>
            <div className="row p-3 justify-content-center">
              <div className="col-md-12">
                <form
                  ref={this.formRef}
                  action="https://www.sandbox.paypal.com/cgi-bin/webscr"
                  method="post"
                  target="_top"
                >
                  <input
                    type="hidden"
                    name="notify_url"
                    id="notify_url"
                    value={notifyUrl}
                  />
                  <input type="hidden" name="cmd" value="_xclick" />
                  <input type="hidden" name="business" value={businessEmail} />
                  <input type="hidden" name="lc" value="USD" />
                  <input type="hidden" name="amount" value={amount} />
                  <input type="hidden" name="currency_code" value={currency} />
                  <input type="hidden" name="rm" value="0" />
                  <input type="hidden" name="no_note" value="0" />
                  <input type="hidden" name="bn" value="GivBee_SP" />
                  <input type="hidden" name="item_name" value={messageName} />
                  <input type="hidden" name="return" value={successUrl} />
                  <input type="hidden" name="cancel_return" value={cancelUrl} />
                  {isAmount && (
                    <div className="amount-wrapper pt-4 pb-4">
                      <label className="amount-label">Enter amount:</label>
                      <div className="input-container">
                        <span className="dollar-sign">$</span>
                        <input
                          type="number"
                          name="amount"
                          id="amount"
                          autoComplete="off"
                          className="amount-input"
                          value={amount}
                          onChange={this.handleAmountChange}
                        />
                      </div>
                    </div>
                  )}
                  {/* Submit Button */}
                  <div className="text-center p-4">
                    {amount > 0 ? (
                      // <Button
                      //   type="button"
                      //   onClick={this.submitForm}
                      //   className="me-2"
                      //   style={{
                      //     padding: "2px 10px",
                      //     background: "#337ab7",
                      //     color: "#fff",
                      //     fontSize: "14px",
                      //     fontWeight: "600",
                      //     width: "150px",
                      //     textTransform: "capitalize",
                      //   }}
                      // >
                      //   Donate {amount ? `$${amount}` : ""}
                      // </Button>
                      <button
                        className="give-button"
                        type="button"
                        onClick={this.submitForm}
                      >
                        <b>
                          <i>Give {amount ? `$${parseFloat(amount)}` : ""}</i>
                        </b>
                      </button>
                    ) : (
                      // <Button
                      //   disabled
                      //   type="button"
                      //   className="me-2"
                      //   style={{
                      //     padding: "2px 10px",
                      //     background: "#337ab7",
                      //     color: "#fff",
                      //     fontSize: "14px",
                      //     fontWeight: "600",
                      //     width: "150px",
                      //     textTransform: "capitalize",
                      //     opacity: 0.6,
                      //   }}
                      // >
                      //   Donate
                      // </Button>
                      <button disabled className="give-button">
                        <b>
                          <i>Give</i>
                        </b>
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
            {/* <div className="row mt-3 justify-content-center">
              <div className="col-md-12" style={{ width: "300px" }}>
                <div class="option_text text-center" id="recringoptiontext">
                  <p
                    className="col form-label align-self-center pe-0 fs-6"
                    htmlFor="collapsible-firstname"
                  >
                    OR
                  </p>
                  <p
                    className="col form-label align-self-center pe-0 fs-6"
                    htmlFor="collapsible-firstname"
                  >
                    Make your donation recurring:
                  </p>
                </div>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  id="recurringForm"
                  method="post"
                  target="_top"
                >
                  <input
                    type="hidden"
                    name="cmd"
                    value="_xclick-subscriptions"
                  />
                  <input type="hidden" name="business" value={businessEmail} />
                  <input type="hidden" name="lc" value="US" />
                  <input type="hidden" name="no_note" value="1" />
                  <input type="hidden" name="src" value="1" />
                  <input
                    type="hidden"
                    name="notify_url"
                  />
                  <input type="hidden" name="currency_code" value="USD" />
                  <input type="hidden" name="bn" value="GivBee_SP" />
                  <input type="hidden" name="option_select0" value="Weekly" />
                  <input type="hidden" name="option_amount0" value={amount} />
                  <input type="hidden" name="option_period0" value="W" />
                  <input type="hidden" name="option_frequency0" value="1" />
                  <input type="hidden" name="option_select1" value="Monthly" />
                  <input type="hidden" name="option_amount1" value={amount} />
                  <input type="hidden" name="option_period1" value="M" />
                  <input type="hidden" name="option_frequency1" value="1" />
                  <input type="hidden" name="option_select2" value="Yearly" />
                  <input type="hidden" name="option_amount2" value={amount} />
                  <input type="hidden" name="option_period2" value="Y" />
                  <input type="hidden" name="option_frequency2" value="1" />
                  <input
                    type="hidden"
                    id="option_index"
                    name="option_index"
                    value={optionIndex}
                  />

                  <div className="row p-2">
                    <div className="col-sm-12 text-center">
                      {amount > 0 ? (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          onClick={() => this.handleOptionChange("Weekly", 0)}
                        >
                          {`$${amount} - Weekly`}
                        </Button>
                      ) : (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          disabled
                          style={{ opacity: 0.6 }}
                        >
                          Weekly
                        </Button>
                      )}
                    </div>
                    <div className="col-sm-12 text-center">
                      {amount > 0 ? (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          disabled={amount > 0}
                          onClick={() => this.handleOptionChange("Monthly", 1)}
                        >
                          {amount > 0 ? `$${amount} - Monthly` : "Monthly"}
                        </Button>
                      ) : (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          disabled
                          style={{ opacity: 0.6 }}
                        >
                          Monthly
                        </Button>
                      )}
                    </div>
                    <div className="col-sm-12 text-center">
                      {amount > 0 ? (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          disabled={amount > 0}
                          onClick={() => this.handleOptionChange("Yearly", 2)}
                        >
                          {amount > 0 ? `$${amount} - Yearly` : "Yearly"}
                        </Button>
                      ) : (
                        <Button
                          className="donationRecurringButton"
                          type="submit"
                          disabled
                          style={{ opacity: 0.6 }}
                        >
                          Yearly
                        </Button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div> */}
            <div className="row p-3 justify-content-center">
              <img
                src={PaypalLogo}
                alt="#"
                class="logo"
                style={{ height: "56px", objectFit: "contain" }}
              />

              <br />
              <a
                href="http://www.givbee.com/"
                class="text-center mt-3 donationfooter-text"
                target="_blank"
              >
                <span className="mb-2">Texting provided by GivBee</span> <br />
                <span>www.givbee.com</span>
                {/* <img
                  style={{ height: "30px", objectFit: "contain" }}
                  src={logo}
                  alt="#"
                /> */}
              </a>
            </div>
          </div>
        </div>
      );
    }
  }
}
export default PaypalDonation;
